var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_package",
    "data-name": "add package",
    transform: "translate(-0.633 0.245)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1660",
    "data-name": "Ellipse 1660",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(0.633 -0.245)",
    fill: "#00C6B1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57761",
    "data-name": "Group 57761",
    transform: "translate(4.622 3.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220482",
    "data-name": "Path 220482",
    d: "M7.286,13.52v5.568A1.414,1.414,0,0,0,8.7,20.5h4.163a.427.427,0,0,0,0-.854H8.7a.561.561,0,0,1-.561-.561V13.52a.427.427,0,0,0-.853,0Z",
    transform: "translate(-6.463 -8.95)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220483",
    "data-name": "Path 220483",
    d: "M17.519,7.868V9.084H6.853V7.868a.4.4,0,0,1,.4-.4h9.874a.4.4,0,0,1,.4.4ZM16.7,9.941v2.438a.427.427,0,1,0,.854,0V9.941h.4a.427.427,0,0,0,.426-.427V7.868a1.249,1.249,0,0,0-1.249-1.249H7.249A1.249,1.249,0,0,0,6,7.868V9.514a.427.427,0,0,0,.427.427Z",
    transform: "translate(-6 -6.619)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220484",
    "data-name": "Path 220484",
    d: "M19.864,17.83a2.034,2.034,0,1,1-2.034,2.034A2.034,2.034,0,0,1,19.864,17.83Zm0-.854a2.888,2.888,0,1,0,2.888,2.888A2.888,2.888,0,0,0,19.864,16.976Z",
    transform: "translate(-9.952 -10.348)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220485",
    "data-name": "Path 220485",
    d: "M20.168,20.168h-.733a.427.427,0,1,0,0,.854h.733v.733a.427.427,0,1,0,.854,0v-.733h.733a.427.427,0,1,0,0-.854h-.733v-.733a.427.427,0,1,0-.854,0Z",
    transform: "translate(-10.683 -11.079)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220486",
    "data-name": "Path 220486",
    d: "M10.5,13.1v2.3a.426.426,0,0,0,.663.355l1-.667,1,.665a.426.426,0,0,0,.663-.355V13.1a.427.427,0,0,0-.853,0v1.5l-.571-.384a.428.428,0,0,0-.474,0l-.571.384V13.1a.427.427,0,0,0-.853,0Z",
    transform: "translate(-7.62 -8.804)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.4817cd71784bc72545c052924625ced5.svg";
export { ForwardRef as ReactComponent };